



































import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'

@Component
export default class TelForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  tel: string

  @Prop({ required: true })
  handleTelChanged: (val: string) => void

  @Prop({ default: false })
  isRequired: boolean

  @Prop({ default: '' })
  namePrefix: string

  @Prop({ default: true })
  showTitle: boolean

  get hasExtendedValidationError(): boolean {
    return !!this.$slots.extendedValidationErrorMessage
  }

  get validation(): any {
    return {
      required: this.isRequired,
      numeric: true,
      tel_number: true,
    }
  }

  nameWithPrefix(name: string) {
    return !!this.namePrefix ? `${this.namePrefix}-${name}` : name
  }

  handleInputTel(tel: string): void {
    this.handleTelChanged(tel)
  }
}
